import React, { useCallback } from 'react';
import { NavPage } from '../../../services/NavService';
import { DoorClient, IDoor2 } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { GenericEditor } from '../GenericEditor';
import { SingleDoorAdmin } from './SingleDoorAdmin';

export function DoorAdmin(props: {

}) {

    const client = useClient(DoorClient);
    const getterFunc = useCallback(
        () => client.getDoors().then(response => response.doors),
        [client]
    );

    function getEditor(door: IDoor2, onChange: (() => void), updateCount: number) {
        return (
            <SingleDoorAdmin door={door} onChange={onChange} key={`${door?.id} ${updateCount}`} />
        );
    }


    return (
        <GenericEditor navPage={NavPage.Admin.Door}
            getterFunc={getterFunc}
            editorFunc={getEditor}
            nameFunc={d => d.defaultName}
        />
    );
}
